<script lang="ts" module>
  import imgNoErrors from '@/assets/no-errors.png';

  export interface NoErrorsProps {
    noErrorTitle: string;
    noErrorText: string;
  }
</script>

<script lang="ts">
  let { ...props }: NoErrorsProps = $props();
</script>

<div class="overflow-hidden rounded-sm">
  <div class="flex items-center justify-center">
    <img src={imgNoErrors} role="presentation" alt="NoErrors" />
  </div>
  <div class="bg-w p-3 font-sans text-sm font-normal text-c-base">
    <h0 class="font-bold">{props.noErrorTitle}</h0>
    <p>{props.noErrorText}</p>
  </div>
</div>
